var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-new-item",on:{"click":function($event){return _vm.gotoPage()}}},[_vm._m(0),_c('h2',{staticClass:"header-2 card-new-item__text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-new-item__icon"},[_c('img',{attrs:{"src":require("@/assets/images/icons/plus.svg")}})])
}]

export { render, staticRenderFns }